<template>
    <div class="message-block-container">
        <div class="columns is-gapless message-block">
            <div class="column is-narrow message-icon"><i class="fad fa-fw fa-2x mr-2" :class="content.icon.icon" :style="{color: content.icon.color}"></i></div>
            <div class="column">
                <render-editor-js :content="content.text.content" :component="{}"/>

            </div>
        </div>
    </div>
</template>

<script>
    import RenderEditorJs from "./RenderEditorJs";

    export default {
        components: {RenderEditorJs},
        props: ['content'],
        methods: {

        },
        created() {

        }
    };
</script>

<style lang="scss">
    .message-block-container {
        margin: 2rem;

        .message-block {
            background-color: #f4f4f4;
            padding: 2rem 2rem 1rem;
            border-radius: 1rem;

            .message-icon {
                font-size: 1rem;

            }

            .render-header {
                padding-top: 4px !important;
                padding-left: 1rem !important;
            }

            .render-paragraph {
                padding-left: 1rem !important;
            }
        }
    }

</style>
